import React, { useEffect, useState } from "react";

import learningPortal from "../../assets/image/learningportal.svg";
import { useRegisterMutation } from "../../features/auth/authAPI";
import { Link } from "react-router-dom";
function StudentRegister() {
  const [formState, setFormState] = useState({
    name: "",
    email: "",
    password: "",
    confirmPassword: "",
  });
  const [register, { isLoading, isError }] = useRegisterMutation();
  const [passwordMatched, setPasswordMatched] = useState(true);

  useEffect(() => {
    if (formState.password === formState.confirmPassword) {
      setPasswordMatched(true);
    } else {
      setPasswordMatched(false);
    }
  }, [formState.password, formState.confirmPassword]);

  function handleChange(event) {
    setFormState({ ...formState, [event.target.name]: event.target.value });
  }

  function handleSubmit(event) {
    event.preventDefault();
    const payload = {
      name: formState.name,
      email: formState.email,
      password: formState.password,
      role: "student",
    };
    //failSafe
    if (passwordMatched) {
      register(payload);
    }
  }
  return (
    <section className="py-6 bg-primary h-screen grid place-items-center">
      <div className="mx-auto max-w-md px-5 lg:px-0">
        <div>
          <img className="h-12 mx-auto" src={learningPortal} alt="brand" />
          <h2 className="mt-6 text-center text-3xl font-extrabold text-slate-100">
            Create Your New Account
          </h2>
        </div>
        <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
          <input type="hidden" name="remember" value="true" />
          {isError && (
            <div
              class="bg-red-100 border border-red-400  px-4 py-3 rounded relative"
              role="alert"
            >
              <strong class="font-bold text-red-700">Error!</strong>
              <span class="block sm:inline text-red-700">
                Registration Failed. Please try again!
              </span>
            </div>
          )}
          <div className="rounded-md shadow-sm -space-y-px">
            <div>
              <label htmlFor="name" className="sr-only">
                Name
              </label>
              <input
                id="name"
                name="name"
                type="name"
                autoComplete="name"
                required
                className="login-input rounded-t-md"
                placeholder="Student Name"
                onChange={handleChange}
              />
            </div>
            <div>
              <label htmlFor="email-address" className="sr-only">
                Email address
              </label>
              <input
                id="email-address"
                name="email"
                type="email"
                autoComplete="email"
                required
                className="login-input "
                placeholder="Email address"
                onChange={handleChange}
              />
            </div>
            <div>
              <label htmlFor="password" className="sr-only">
                Password
              </label>
              <input
                id="password"
                name="password"
                type="password"
                autoComplete="current-password"
                required
                className="login-input"
                placeholder="Password"
                onChange={handleChange}
              />
            </div>
            <div>
              <label htmlFor="confirm-password" className="sr-only">
                Confirm Password
              </label>
              <input
                id="confirm-password"
                name="confirmPassword"
                type="password"
                autoComplete="confirm-password"
                required
                className="login-input rounded-b-md"
                placeholder="Confirm Password"
                onChange={handleChange}
              />
              {!passwordMatched && (
                <span className="bg-red text-gray-400 text-sm -space-y-px">
                  Passwords Do not Match! Please enter same password in both
                  fields.
                </span>
              )}
            </div>
          </div>

          <div>
            <button
              type="submit"
              className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-violet-600 hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violet-500"
              disabled={isLoading || !passwordMatched}
            >
              Create Account
            </button>
          </div>
        </form>
        <div className="flex items-center my-3">
          <div className="text-sm">
            <span className="font-medium text-violet-600 hover:text-violet-500">
              Already have an account?
            </span>
          </div>
        </div>
        <div>
          <Link to="/login">
            <button className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-cyan hover:bg-cyan focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violet-500">
              Sign In
            </button>
          </Link>
        </div>
      </div>
    </section>
  );
}

export default StudentRegister;
